import defaultGameMenuConfig from '../data/gameMenuDefaults.json';

const clone = (value) => JSON.parse(JSON.stringify(value));

const mergeKnown = (defaultValue, candidateValue) => {
  if (Array.isArray(defaultValue)) return Array.isArray(candidateValue) ? candidateValue : clone(defaultValue);
  if (defaultValue && typeof defaultValue === 'object') {
    return Object.fromEntries(Object.entries(defaultValue).map(([key, value]) => [
      key,
      mergeKnown(value, candidateValue && typeof candidateValue === 'object' ? candidateValue[key] : undefined),
    ]));
  }
  return candidateValue === undefined ? defaultValue : candidateValue;
};

export const getDefaultGameMenuConfig = () => clone(defaultGameMenuConfig);

export const normalizeLoadedGameMenuConfig = (candidate) => {
  const config = mergeKnown(defaultGameMenuConfig, candidate);
  if (config.presentation.title.toLocaleLowerCase('es-MX').includes('pulso del diablito')) {
    config.presentation.title = defaultGameMenuConfig.presentation.title;
  }
  if (config.presentation.description.toLocaleLowerCase('es-MX').startsWith('sigue la señal')) {
    config.presentation.description = defaultGameMenuConfig.presentation.description;
  }
  if (['iniciar el ritual', 'maldecir', 'maldición'].includes(config.presentation.startButtonLabel.toLocaleLowerCase('es-MX'))) {
    config.presentation.startButtonLabel = defaultGameMenuConfig.presentation.startButtonLabel;
  }
  return config;
};

export const fetchGameMenuConfig = async (signal) => {
  const response = await fetch('/api/config/game-menu', {
    headers: { Accept: 'application/json' },
    signal,
  });
  if (!response.ok) throw new Error(`El backend respondio ${response.status}.`);
  const payload = await response.json();
  return {
    config: normalizeLoadedGameMenuConfig(payload.config),
    meta: payload.meta,
  };
};
